<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Cercar')"></BreadcrumSection>


    <div v-if="responseProfessors?.total === 0 &&
      responseOrganitzacions?.total === 0 &&
      responseAssignatures?.total === 0 &&
      responseTitulacions?.total === 0 &&
      responseMaterials?.total === 0 &&
      responseMaterialsAccesObert?.total === 0 &&
      responseMaterialsPfc?.total === 0 &&
      responseMaterialsVideos?.total === 0" class="alert alert-danger rounded-0" role="alert">
      {{ $t("No results") }}
    </div>


    <div v-else class="row">

      <div class="col-sm-12 col-md-12" >

        <div v-if="responseProfessors.total !== 0" class="mb-5">
          <h1>{{ $t("Professorat") }}</h1>
          <ul class="list-group list-group-flush mb-3" >
            <li>
              <router-link-locale
                  v-for="(professor) in responseProfessors.professors"
                  :key="professor.id"
                  :to="{name: 'professor', params: {id: professor.id}}"
                  class="list-group-item list-group-item-action flex-column align-items-start p-2"
              >

                <div class="d-flex justify-content-between mb-1">
                  <span class="text-blue">{{ professor.professor_nom }}</span>
                  <span class="text-secondary">Activitats<span class="badge rounded-pill badge-upc ms-2">{{ professor.professor_num_activitats }}</span> </span>
                </div>

                <div>
                  <div class="text-secondary mb-1" v-if="professor.professor_departament">
                    <span v-for="departament in professor.professor_departament" v-bind:key="departament">
                      {{ $t(departament) }}
                    </span>
                  </div>

                  <div class="mb-1" v-if="professor.professor_centre_docent">
                    <span v-for="centre in professor.professor_centre_docent" v-bind:key="centre">
                      {{ $t(centre) }}
                    </span>
                  </div>

                  <div class="color-verd fw-bolder mb-1" v-if="professor.professor_campus">
                    <span v-if="professor.professor_campus !== 'EXTERN'">{{ professor.professor_campus }}</span>
                  </div>
                </div>
              </router-link-locale>
            </li>
          </ul>
          <router-link-locale v-if="responseProfessors.total > SIZE" :to="{name: 'professorat', params: {page: 1, sort: 'professor_nom_sort asc'}, query: {professor_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseOrganitzacions.total !== 0" class="mb-5">
          <h1>{{ $t("Organitzacions") }}</h1>
          <ul class="list-group list-group-flush mb-3" >
            <li>
              <router-link-locale
                  v-for="(organitzacio) in responseOrganitzacions.organitzacions"
                  :key="organitzacio.id"
                  :to="{name: 'organitzacio', params: {id: organitzacio.id}}"
                  class="list-group-item list-group-item-action flex-column align-items-start p-2"
                  tag="li"
              >

                <div class="mb-1">
                  <span class="text-blue">{{ organitzacio[`organitzacio_nom_${locale}`] }}</span>
                </div>

                <div>
                  <div class="text-secondary mb-1">
                    <span>{{ organitzacio.organitzacio_sigles }}</span>
                  </div>

                  <div class="mb-1" >
                    <span>{{ $t(organitzacio.subtipus) }}</span>
                  </div>

                </div>
              </router-link-locale>
            </li>
          </ul>
          <router-link-locale v-if="responseOrganitzacions.total > SIZE" :to="{name: 'organitzacions', params: {page: 1, sort: 'organitzacio_nom_ca asc'}, query: {organitzacio_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseAssignatures.total !== 0" class="mb-5">
          <h1>{{ $t("Assignatures") }}</h1>
          <ul class="list-group list-group-flush mb-3" >
            <li>
              <router-link-locale
                  v-for="(assignatura) in responseAssignatures.assignatures"
                  :key="assignatura.id"
                  :to="{name: 'assignatura', params: {id: assignatura.id}}"
                  class="list-group-item list-group-item-action flex-column align-items-start p-2"
                  tag="li"
              >

                <div class="mb-1">
                  <span v-if="assignatura[`assignatura_nom_${locale}`]" class="text-blue">{{ assignatura[`assignatura_nom_${locale}`] }}</span>
                  <span v-else class="text-blue">{{ assignatura.assignatura_nom_ca }}</span>

                </div>

                <div class="fw-bolder mb-1">
                  <span>{{ assignatura.assignatura_sigles }}</span>
                </div>

                <div class="mb-1" v-if="assignatura.assignatura_centres">
                <span v-for="centre in (assignatura.assignatura_centres.filter((valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual))" v-bind:key="centre">
                  {{ $t(centre) }}
                </span>
                </div>

                <div class="mt-2 text-secondary " v-if="assignatura.assignatura_titulacions">
                  <div v-for="(titulacio, index) in assignatura.assignatura_titulacions" v-bind:key="titulacio">
                    <div class="d-flex w-100 justify-content-between">
                      <span>{{ $t(titulacio) }}</span>
                      <span v-if="getTipusAssignatura(assignatura.assignatura_tipus, index) === 'OB'" class="mb-1"><span class="badge badge-upc">{{ $t('OB') }}</span></span>
                      <span v-else-if="getTipusAssignatura(assignatura.assignatura_tipus, index) === 'OP'" class="mb-1"><span class="badge bg-success">{{ $t('OP') }}</span></span>
                      <span v-else-if="getTipusAssignatura(assignatura.assignatura_tipus, index) === 'ALE'" class="mb-1"> <span class="badge bg-danger">{{ $t('ALE') }}</span></span>
                      <span v-else class="mb-1"><span class="badge bg-dark">{{ $t('OTHER') }}</span></span>
                    </div>
                  </div>
                </div>

              </router-link-locale>
            </li>
          </ul>
          <router-link-locale v-if="responseAssignatures.total > SIZE" :to="{name: 'assignatures', params: {page: 1, sort: 'assignatura_nom_ca asc'}, query: {assignatura_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>

        <div v-if="responseTitulacions.total !== 0">
          <h1>{{ $t("Titulacions") }}</h1>
          <ul class="list-group list-group-flush mt-1" >
            <li>
              <router-link-locale
                  v-for="(titulacio) in responseTitulacions.titulacions"
                  :key="titulacio.id"
                  :to="{name: 'titulacio', params: {id: titulacio.id}}"
                  class="list-group-item list-group-item-action flex-column align-items-start p-2"
                  tag="li"
              >

                <div class="mb-1 d-flex w-100 justify-content-between">
                  <span v-if="titulacio[`titulacio_nom_${locale}`]" class="text-blue">{{ titulacio[`titulacio_nom_${locale}`] }}</span>
                  <span v-else class="text-blue">{{ titulacio.titulacio_nom_ca }}</span>
                  <span class="text-secondary">
                    <span v-if="titulacio.titulacio_activa" class="badge bg-success">{{ $t("Activa") }}</span>
                    <span v-else class="badge bg-danger">{{ $t("No activo") }}</span>
                  </span>

                </div>

                <div class="fw-bolder mb-1">
                  <span>{{ titulacio.titulacio_sigles }}</span>
                </div>

                <div class="mb-1 text-secondary">
                  <span>{{ $t(titulacio.titulacio_centre) }}</span>
                </div>

                <div class="mb-1 color-vermell fw-bolder">
                  <span>{{ titulacio.titulacio_nivell }}</span>
                </div>

              </router-link-locale>
            </li>
          </ul>
          <router-link-locale v-if="responseTitulacions.total > SIZE" :to="{name: 'titulacions', params: {page: 1, sort: 'titulacio_sigles asc'}, query: {titulacio_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseMaterials.total !== 0">
          <h1>{{ $t("Materials") }}</h1>
          <ListActivitats :materials="responseMaterials.materials" class="mb-4"></ListActivitats>
          <router-link-locale v-if="responseMaterials.total > SIZE" :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {activitat_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseMaterialsAccesObert.total !== 0">
          <h1>{{ $t("Accés Obert") }}</h1>
          <ListActivitats :materials="responseMaterials.materials" class="mb-4"></ListActivitats>
          <router-link-locale v-if="responseMaterials.total > SIZE" :to="{name: 'accesObert', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {activitat_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseMaterialsPfc.total !== 0">
          <h1>{{ $t("Treballs Finals") }}</h1>
          <ListActivitats :materials="responseMaterialsPfc.materials" class="mb-4"></ListActivitats>
          <router-link-locale v-if="responseMaterialsPfc.total > SIZE" :to="{name: 'treballsFinals', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {activitat_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>


        <div v-if="responseMaterialsVideos.total !== 0">
          <h1>{{ $t("Vídeos") }}</h1>
          <ListActivitats :materials="responseMaterialsVideos.materials" class="mb-4"></ListActivitats>
          <router-link-locale v-if="responseMaterialsVideos.total > SIZE" :to="{name: 'videos', params: {page: 1, sort: 'data desc, activitat_data_available desc'}, query: {activitat_cerca: q}}" class="button-link mt-3 mb-5 d-flex">
            <button type="button" class="btn btn-warning text-white"> <i class="fas fa-plus"></i> {{ $t("Veure tots els resultats") }}</button>
          </router-link-locale>
        </div>






      </div>



    </div>

  </div>

</template>

<script>

import {onMounted, ref} from "vue";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {useRoute} from "vue-router";
import store from "@/store";
import ProfessorService from "@/services/ProfessorService";
import OrganitzacioService from "@/services/OrganitzacioService";
import AssignaturaService from "@/services/AssignaturaService";
import TitulacioService from "@/services/TitulacioService";
import MaterialService from "@/services/MaterialService";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import {useI18n} from "vue-i18n";
import {getTipusAssignatura} from "@/composables/pageFunctions";
import ListActivitats from "@/components/ListActivitats.vue";


  export default {
    name: "CercarView",
    methods: {getTipusAssignatura},
    components: {ListActivitats, RouterLinkLocale, BreadcrumSection},

    setup(){
      const { locale } = useI18n();
      const route = useRoute()
      const q = ref(route.query.q)
      const SIZE = 5

      const responseProfessors = ref({ total: 0, professors: [] });
      const responseOrganitzacions = ref({ total: 0, organitzacions: [] });
      const responseAssignatures = ref({ total: 0, assignatures: [] });
      const responseTitulacions = ref({ total: 0, titulacions: [] });
      const responseMaterials = ref({ total: 0, materials: [] });
      const responseMaterialsAccesObert = ref({ total: 0, materials: [] });
      const responseMaterialsPfc = ref({ total: 0, materials: [] });
      const responseMaterialsVideos = ref({ total: 0, materials: [] });

      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Tots");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-green-blue.webp') });

        responseProfessors.value = await ProfessorService.getProfessors(0, SIZE, `tipus:professor AND professor_cerca:${q.value}`, "professor_nom_sort asc" )
        responseOrganitzacions.value = await OrganitzacioService.getOrganitzacions(0, SIZE, `tipus:organitzacio AND organitzacio_cerca:${q.value}`, "organitzacio_nom_ca asc" )
        responseAssignatures.value = await AssignaturaService.getAssignatures(0, SIZE, `tipus:assignatura AND assignatura_cerca:${q.value}`, "assignatura_nom_ca asc" )
        responseTitulacions.value = await TitulacioService.getTitulacions(0, SIZE, `tipus:titulacio AND titulacio_cerca:${q.value}`, "titulacio_sigles asc" )
        responseMaterials.value = await MaterialService.getMaterials(0, SIZE, `tipus:material AND activitat_cerca:${q.value}`, "data desc, activitat_data_available desc" )
        responseMaterialsAccesObert.value = await MaterialService.getMaterials(0, SIZE, `activitat_rights:"Open Access" AND activitat_cerca:${q.value}`, "data desc, activitat_data_available desc" )
        responseMaterialsPfc.value = await MaterialService.getMaterials(0, SIZE, `activitat_comunitat:pfc AND activitat_cerca:${q.value}`, "data desc, activitat_data_available desc" )
        responseMaterialsVideos.value = await MaterialService.getMaterials(0, SIZE, `activitat_comunitat:videodocent AND activitat_cerca:${q.value}`, "data desc, activitat_data_available desc" )
      });


      return{
        q,
        SIZE,
        locale,
        responseProfessors,
        responseOrganitzacions,
        responseAssignatures,
        responseTitulacions,
        responseMaterials,
        responseMaterialsAccesObert,
        responseMaterialsPfc,
        responseMaterialsVideos
      }
    }
  }

</script>

<style scoped>

.button-link {
  text-decoration: none;
  color: inherit;
}

h1 {
  margin: -6px 0 0 0;
  border-bottom: 0;
}
</style>
